// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__ZuGsc","part":"loader_part__jyYzR","ring":"loader_ring__73tXx"};